import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { FaMapMarkerAlt, FaSearch, FaTimes, FaDollarSign, FaRulerCombined } from 'react-icons/fa';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Komponenty i zasoby
import Card from './Card';
import zdjecia1 from '../assets/zdjecia1.webp';
import zdjecia2 from '../assets/zdjecia2.webp';
import zdjecia3 from '../assets/zdjecia3.webp';

const Hero = () => {
    // Stan i logika pobierania danych (bez zmian)
    const [searchData, setSearchData] = useState({
        miejscowosc_dzielnica: '',
        typ_nieruchomosci: '',
        transakcja: '',
        cena_od: '',
        cena_do: '',
        powierzchnia_od: '',
        powierzchnia_do: '',
    });
    const [filteredResults, setFilteredResults] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [citySuggestions, setCitySuggestions] = useState([]);
    const [cities, setCities] = useState([]);

    useEffect(() => {
        AOS.init({ duration: 800, once: true });
        const fetchCities = async () => {
            try {
                const response = await axios.get('/miasta.txt');
                const cityList = response.data.split('\n').map(city => city.trim()).filter(Boolean);
                setCities(cityList);
            } catch (err) { console.error('Błąd pobierania miast:', err); }
        };
        fetchCities();
    }, []);

    const fetchListings = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.post('https://www.wltz.space/php/src/api/ogloszenia.php', searchData);
            setFilteredResults(response.data);
        } catch (err) {
            setError('Wystąpił błąd podczas pobierania ogłoszeń.');
        } finally {
            setLoading(false);
        }
    }, [searchData]);

    useEffect(() => { fetchListings(); }, [fetchListings]);
    useEffect(() => {
        if (showSuggestions && searchData.miejscowosc_dzielnica.length >= 2) {
            setCitySuggestions(cities.filter(city => city.toLowerCase().startsWith(searchData.miejscowosc_dzielnica.toLowerCase())));
        } else {
            setCitySuggestions([]);
        }
    }, [searchData.miejscowosc_dzielnica, showSuggestions, cities]);

    const handleChange = (e) => setSearchData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    const handleClear = (field) => setSearchData(prev => ({ ...prev, [field]: '' }));
    const handleCitySelect = (city) => {
        setSearchData(prev => ({ ...prev, miejscowosc_dzielnica: city }));
        setShowSuggestions(false);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setCurrentPage(1);
        fetchListings();
    };
    const prevPage = () => { if (currentPage > 1) setCurrentPage(prev => prev - 1); };
    const nextPage = () => { if (currentPage < Math.ceil(filteredResults.length / itemsPerPage)) setCurrentPage(prev => prev + 1); };
    const currentListings = filteredResults.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <section id="offers">
            {/* ZMIANA: Zmniejszona i ustalona wysokość sekcji Hero, content wycentrowany */}
            <div className="relative h-[700px] md:h-[600px] flex items-center justify-center text-center" data-aos="fade-in">
                <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false} interval={5000} className="absolute inset-0 z-0">
                    {/* ZMIANA: Wysokość diva i obrazka dopasowana do kontenera */}
                    {[zdjecia1, zdjecia2, zdjecia3].map((img, index) => (
                        <div key={index} className="h-full">
                            <img src={img} alt={`Tło ${index + 1}`} className="h-96 w-full object-cover" />
                        </div>
                    ))}
                </Carousel>
                {/* ZMIANA: Ulepszony gradient dla lepszej czytelności */}
                <div className="absolute inset-0 bg-gradient-to-t z-10"></div>

                <div className="relative z-20 container mx-auto px-4 -mt-56 w-full">
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight" data-aos="fade-down">
                        Znajdź Nieruchomość Swoich Marzeń
                    </h1>
                    <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-200" data-aos="fade-down" data-aos-delay="200">
                        Odkryj najlepsze oferty w jednym miejscu. Zaczynajmy!
                    </p>

                    <form onSubmit={handleSubmit} className="mt-2 max-w-6xl mx-auto bg-white p-6 rounded-xl shadow-2xl text-left" data-aos="fade-up" data-aos-delay="400">
                        {/* Formularz bez zmian w strukturze, jest poprawny */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-x-4 gap-y-5 items-end">
                            <div className="relative lg:col-span-3 md:col-span-2">
                                <label htmlFor="miejscowosc_dzielnica" className="block text-sm font-medium text-gray-700 mb-1">Lokalizacja</label>
                                <FaMapMarkerAlt className="absolute left-3 bottom-3 text-gray-400" />
                                <input id="miejscowosc_dzielnica" name="miejscowosc_dzielnica" type="text" value={searchData.miejscowosc_dzielnica} onChange={handleChange} placeholder="Miasto, dzielnica..." onClick={() => setShowSuggestions(true)} className="w-full bg-gray-50 border border-gray-300 rounded-lg p-2.5 pl-10 focus:ring-2 focus:ring-[#a07c5c] focus:border-[#a07c5c] transition" />
                                {searchData.miejscowosc_dzielnica && <FaTimes onClick={() => handleClear('miejscowosc_dzielnica')} className="absolute right-3 bottom-3 text-gray-400 cursor-pointer hover:text-gray-600" />}
                                {showSuggestions && citySuggestions.length > 0 && (
                                    <ul className="absolute w-full mt-1 bg-white text-black rounded-lg shadow-lg max-h-60 overflow-y-auto z-30 border">
                                        {citySuggestions.map((city, idx) => <li key={idx} onMouseDown={() => handleCitySelect(city)} className="p-2 cursor-pointer hover:bg-gray-100">{city}</li>)}
                                    </ul>
                                )}
                            </div>
                            <div className="lg:col-span-3 md:col-span-1">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Cena (PLN)</label>
                                <div className="grid grid-cols-2 gap-2">
                                    <div className="relative"><FaDollarSign className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" /><input name="cena_od" type="number" value={searchData.cena_od} onChange={handleChange} placeholder="od" className="w-full bg-gray-50 border border-gray-300 rounded-lg p-2.5 pl-8 focus:ring-2 focus:ring-[#a07c5c] focus:border-[#a07c5c] transition" /></div>
                                    <div className="relative"><FaDollarSign className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" /><input name="cena_do" type="number" value={searchData.cena_do} onChange={handleChange} placeholder="do" className="w-full bg-gray-50 border border-gray-300 rounded-lg p-2.5 pl-8 focus:ring-2 focus:ring-[#a07c5c] focus:border-[#a07c5c] transition" /></div>
                                </div>
                            </div>
                            <div className="lg:col-span-3 md:col-span-1">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Powierzchnia (m²)</label>
                                <div className="grid grid-cols-2 gap-2">
                                    <div className="relative"><FaRulerCombined className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" /><input name="powierzchnia_od" type="number" value={searchData.powierzchnia_od} onChange={handleChange} placeholder="od" className="w-full bg-gray-50 border border-gray-300 rounded-lg p-2.5 pl-8 focus:ring-2 focus:ring-[#a07c5c] focus:border-[#a07c5c] transition" /></div>
                                    <div className="relative"><FaRulerCombined className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" /><input name="powierzchnia_do" type="number" value={searchData.powierzchnia_do} onChange={handleChange} placeholder="do" className="w-full bg-gray-50 border border-gray-300 rounded-lg p-2.5 pl-8 focus:ring-2 focus:ring-[#a07c5c] focus:border-[#a07c5c] transition" /></div>
                                </div>
                            </div>
                            <div className="md:col-span-2 lg:col-span-2">
                                <button type="submit" className="w-full bg-[#a07c5c] text-white p-3 rounded-lg flex items-center justify-center font-bold text-base hover:bg-[#795b40] transition-transform transform hover:scale-105 shadow-lg">
                                    <FaSearch className="mr-2" /> Szukaj
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* ZMIANA: Usunięto problematyczne marginesy, sekcja wyników płynnie następuje po Hero */}
            <div className="bg-slate-50 -mt-48">
                <div className="container mx-auto px-4 py-2">
                    {loading ? ( <div className="text-center py-16 text-lg text-gray-600">Ładowanie ofert...</div>
                    ) : error ? ( <div className="text-center py-16 text-red-600 font-semibold my-4">Błąd: {error}</div>
                    ) : filteredResults.length > 0 ? (
                        <>
                            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Wyniki wyszukiwania</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                                {currentListings.map(item => <Card key={item.id_ogloszenia} item={item} />)}
                            </div>
                            <div className="flex justify-center mt-6">
                                <button onClick={prevPage} disabled={currentPage === 1} className="bg-white border border-gray-300 hover:bg-gray-100 text-gray-800 font-bold py-2 px-6 rounded-l disabled:opacity-50 disabled:cursor-not-allowed transition">Poprzednia</button>
                                <button onClick={nextPage} disabled={currentPage * itemsPerPage >= filteredResults.length} className="bg-white border border-gray-300 hover:bg-gray-100 text-gray-800 font-bold py-2 px-6 rounded-r disabled:opacity-50 disabled:cursor-not-allowed transition">Następna</button>
                            </div>
                        </>
                    ) : (
                        <div className="text-center bg-white rounded-lg shadow-md py-16">
                            <h3 className="text-2xl font-semibold text-gray-700">Nie znaleziono ofert</h3>
                            <p className="mt-2 text-gray-500">Spróbuj zmienić kryteria wyszukiwania lub sprawdź ponownie później.</p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Hero;